<style lang='stylus'scoped>
active = #336db0;

header {
  margin-bottom: 20px;
  text-align:left;
}

.title {
  font-size: 16px;
  color: #999999;
  position: relative;
  margin-right: 20px;

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: active;

  &::after {
    background: @color;
  }
}

span {
  cursor: pointer;
}
</style>

<template>
  <header>
    <span
      v-for="(item,index) in titleArr"
      :key="index"
      :class="{'title':true,'active':tab === index}"
      @click="changeTab(index)"
    >{{item}}</span>
  </header>
</template>
<script>
export default {
  props: {
    titleArr: {
      type: Array,
      default: []
    },
    changeTab: {
      type: Function,
      default: () => {}
    },
    tab: {
      type: Number,
      default: 0
    }
  },
  methods: {}
}
</script>